import { HttpErrorResponse } from '@angular/common/http';

/**
 * "Riprova tra …" per una risposta 429, leggendo `Retry-After` (secondi). Senza intestazione
 * leggibile resta generico: meglio vago che un numero inventato.
 */
export function retryAfterText(error: HttpErrorResponse): string {
  const seconds = Number(error.headers.get('Retry-After'));
  if (!Number.isFinite(seconds) || seconds <= 0) {
    return 'tra qualche minuto';
  }
  if (seconds < 60) {
    return 'tra meno di un minuto';
  }
  const minutes = Math.ceil(seconds / 60);
  return minutes === 1 ? 'tra un minuto' : `tra ${minutes} minuti`;
}
